import(/* webpackMode: "eager" */ "/home/nodejs/apps/remed/frontend/src/app/page.tsx")